export default __webpack_public_path__ + "static/media/kakao-white.0deeecdf.png";